import PropTypes from "prop-types"
import {
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
} from "@mui/material"
import MDButton from "components/MDButton"
import { useState, useEffect } from "react"
import { CalendarToday, Close } from "@mui/icons-material"
import config from "config"
import { useMaterialUIController } from "context"
import "flatpickr/dist/themes/dark.css"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/l10n/es.js"

function FilterCard(props) {
  // Changed Stadistic to Statistic
  const [controller] = useMaterialUIController()
  const { darkMode } = controller
  const { title, onClose, selectedValue, open, onSearch } = props

  const [selectedEmpresas, setSelectedEmpresas] = useState("")
  const [selectedSucursales, setSelectedSucursales] = useState("")
  const [selectedEventos, setSelectedEventos] = useState("")
  const [selectedZonas, setSelectedZonas] = useState("")
  const [empresas, setEmpresas] = useState([])
  const [sucursales, setSucursales] = useState([])
  const [eventos, setEventos] = useState([])
  const [zonas, setZonas] = useState([])
  const [ip, setIp] = useState("")
  const [nombreDispositivo, setNombreDispositivo] = useState("")
  const [fechaDesde, setFechaDesde] = useState()
  const [fechaHasta, setFechaHasta] = useState()

  const resetValues = () => {
    setSelectedEmpresas("")
    setSelectedSucursales("")
    setSelectedEventos("")
    setSelectedZonas("")
    setIp("")
    setNombreDispositivo("")
    setFechaDesde(null)
    setFechaHasta(null)
  }

  const getEmpresas = async () => {
    try {
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      let empUrl = `${config.api.baseURL}/empresas`
      const response = await fetch(empUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        if (result) {
          setEmpresas(result)
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchSucursales = async (selectedId) => {
    try {
      if (selectedId) {
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
        let sucuUrl = `${config.api.baseURL}/sucursales/empresa/${selectedId}`
        const response = await fetch(sucuUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.status === 200) {
          const result = await response.json()
          setSelectedSucursales("")
          if (result) {
            setSucursales(result)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchEventos = async (selectedId) => {
    try {
      if (selectedId) {
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
        let sucuUrl = `${config.api.baseURL}/eventos/empresa/${selectedId}`
        const response = await fetch(sucuUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.status === 200) {
          const result = await response.json()
          setSelectedEventos("")
          if (result) {
            setEventos(result)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchZonas = async (selectedId) => {
    try {
      if (selectedId) {
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
        let zonaUrl = `${config.api.baseURL}/zonas/sucursal/${selectedId}`
        const response = await fetch(zonaUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.status === 200) {
          const result = await response.json()
          setSelectedZonas("")
          if (result) {
            setZonas(result)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleEmpresasChange = (e) => {
    const selectedId = e.target.value
    setSelectedEmpresas(selectedId)
    fetchSucursales(selectedId)
    fetchEventos(selectedId)
  }

  const handleSucursalesChange = (e) => {
    const selectedId = e.target.value
    setSelectedSucursales(selectedId)
    fetchZonas(selectedId)
  }

  const handleEventosChange = (e) => {
    const selectedId = e.target.value
    setSelectedEventos(selectedId)
    fetchZonas(selectedId)
  }

  const handleClearFilters = () => {
    resetValues() // Reset all filter states
  }

  useEffect(() => {
    if (open) {
      getEmpresas()
    }
  }, [open])

  const handleClose = () => {
    onClose(selectedValue)
  }

  const dialogStyle = {
    backgroundColor: darkMode ? "#1a2035" : "#ffffff",
    color: darkMode ? "#ffffff" : "#1a2035",
  }

  const menuItemStyle = {
    color: darkMode ? "#ffffff" : "#1a2035",
    backgroundColor: darkMode ? "#1a2035" : "#ffffff",
  }

  return (
    <Dialog
      PaperProps={{
        style: dialogStyle,
      }}
      open={open}
    >
      <DialogTitle
        sx={{
          borderBottom: darkMode ? "1px solid #2d2d2d" : "1px solid #e0e0e0",
          color: darkMode ? "white" : "dark",
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: darkMode ? "grey" : "dark",
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: darkMode ? "#ffffff" : "#1a2035" }}>Empresa</InputLabel>
              <Select
                label="Empresa"
                variant="outlined"
                fullWidth
                value={selectedEmpresas}
                onChange={handleEmpresasChange}
                sx={{
                  ...menuItemStyle,
                  p: 1.5,
                  "& .MuiSvgIcon-root": { color: darkMode ? "white" : "black" },
                }}
                placeholder="Seleccione.."
              >
                <MenuItem sx={menuItemStyle} value="">
                  Ninguna
                </MenuItem>
                {empresas.map((emp) => (
                  <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                    {emp.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: darkMode ? "#ffffff" : "#1a2035" }}>Sucursal</InputLabel>
              <Select
                label="Sucursal"
                variant="outlined"
                fullWidth
                value={selectedSucursales}
                onChange={handleSucursalesChange}
                sx={{
                  ...menuItemStyle,
                  p: 1.5,
                  "& .MuiSvgIcon-root": { color: darkMode ? "white" : "black" },
                }}
                placeholder="Seleccione.."
              >
                <MenuItem value="">Ninguna</MenuItem>
                {sucursales?.map((sucu) => (
                  <MenuItem key={sucu.idSucursal} value={sucu.idSucursal}>
                    {sucu.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: darkMode ? "#ffffff" : "#1a2035" }}>Evento</InputLabel>
              <Select
                label="Evento"
                variant="outlined"
                fullWidth
                value={selectedEventos}
                onChange={handleEventosChange}
                sx={{
                  ...menuItemStyle,
                  p: 1.5,
                  "& .MuiSvgIcon-root": { color: darkMode ? "white" : "black" },
                }}
                placeholder="Seleccione.."
              >
                <MenuItem value="">Ninguna</MenuItem>
                {eventos?.map((sucu) => (
                  <MenuItem key={sucu.idEvento} value={sucu.idEvento}>
                    {sucu.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel sx={{ color: darkMode ? "#ffffff" : "#1a2035" }}>Zonas</InputLabel>
              <Select
                label="Zona"
                variant="outlined"
                fullWidth
                value={selectedZonas}
                onChange={(e) => setSelectedZonas(e.target.value)}
                sx={{
                  ...menuItemStyle,
                  p: 1.5,
                  "& .MuiSvgIcon-root": {
                    color: darkMode ? "white" : "black",
                    right: "8px", // Ensure proper positioning
                  },
                }}
                placeholder="Seleccione.."
              >
                <MenuItem value="">Ninguna</MenuItem>
                {zonas?.map((z) => (
                  <MenuItem key={z.idZona} value={z.idZona}>
                    {z.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl fullWidth>
              <TextField
                label="IP equipo"
                variant="outlined"
                fullWidth
                value={ip}
                onChange={(e) => setIp(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl fullWidth>
              <TextField
                label="Nombre del dispositivo"
                variant="outlined"
                fullWidth
                value={nombreDispositivo}
                onChange={(e) => setNombreDispositivo(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <Flatpickr
              value={fechaDesde}
              options={{
                locale: "es",
                enableTime: true,
                time_24hr: true,
                defaultHour: new Date().getHours(), // Set default hour to the current hour
                defaultMinute: new Date().getMinutes(), // Set default minute to the current minute
              }}
              onChange={(date) => {
                setFechaDesde(date[0])
              }}
              render={({ defaultValue, value, ...props }, ref) => (
                <TextField
                  fullWidth
                  label="Fecha Desde"
                  variant="outlined"
                  value={fechaDesde ? fechaDesde.toLocaleString() : ""}
                  inputRef={ref}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarToday color={darkMode ? "white" : "black"} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <Flatpickr
              value={fechaHasta}
              options={{
                locale: "es",
                enableTime: true,
                time_24hr: true,
                defaultHour: new Date().getHours(), // Set default hour to the current hour
                defaultMinute: new Date().getMinutes(), // Set default minute to the current minute
              }}
              onChange={(date) => {
                setFechaHasta(date[0])
              }}
              render={({ defaultValue, value, ...props }, ref) => (
                <TextField
                  fullWidth
                  label="Fecha Hasta"
                  variant="outlined"
                  value={fechaHasta ? fechaHasta.toLocaleString() : ""}
                  inputRef={ref}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarToday color={darkMode ? "white" : "black"} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <MDButton
              color="info"
              variant="gradient"
              onClick={() =>
                onSearch(
                  selectedEmpresas,
                  selectedSucursales,
                  selectedEventos,
                  selectedZonas,
                  ip,
                  nombreDispositivo,
                  fechaDesde,
                  fechaHasta
                )
              }
              fullWidth
            >
              Buscar
            </MDButton>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <MDButton color="info" variant="outlined" onClick={handleClearFilters} fullWidth>
              Limpiar
            </MDButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

FilterCard.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string,
}

FilterCard.defaultProps = {
  onSearch: (
    selectedEmpresas,
    selectedSucursales,
    selectedEventos,
    selectedZonas,
    startDate,
    endDate
  ) => {},
}

export default FilterCard
